import ShopriteCard from './ShopriteCard';
import './ShopriteCard.css';

export default ShopriteCard;



// WEBPACK FOOTER //
// ./src/components/ShopriteCard/index.js